import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
type FAQItem = {
  question: string;
  answer: string;
};
function FAQCard({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <div className="rounded-xl overflow-hidden" style={{
    background: '#162030',
    border: `1px solid ${open ? 'rgba(212,168,83,0.3)' : 'rgba(255,255,255,0.06)'}`,
    transition: 'border-color 0.3s ease'
  }} data-id="element-1">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-5 md:p-6 text-left" aria-expanded={open} data-id="element-2">
        <span className="text-base font-medium pr-4" style={{
        fontFamily: 'DM Sans, sans-serif',
        color: '#F5F0E8'
      }} data-id="element-3">
          {item.question}
        </span>
        <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm transition-transform duration-300" style={{
        background: open ? 'rgba(212,168,83,0.2)' : 'rgba(255,255,255,0.05)',
        color: open ? '#D4A853' : '#8A8070',
        transform: open ? 'rotate(45deg)' : 'rotate(0deg)'
      }} data-id="element-4">
          +
        </span>
      </button>
      {open && <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-5">
          <p className="text-sm leading-relaxed" style={{
        fontFamily: 'DM Sans, sans-serif',
        color: '#8A8070'
      }} data-id="element-6">
            {item.answer}
          </p>
        </div>}
    </div>;
}
export function FAQSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const faqs: FAQItem[] = [{
    question: "Est-ce que c'est de la méditation ?",
    answer: "Non, pas du tout. C'est une technique basée sur la physiologie du système nerveux. Là où la méditation demande de calmer l'esprit par la pensée, le Reset Somatique agit directement sur le corps pour couper le signal de stress — même quand votre tête est encore en ébullition."
  }, {
    question: 'Ai-je besoin de matériel ?',
    answer: "Juste un carnet, un stylo et vous-même. Pas d'application, pas d'abonnement, pas d'équipement spécial. Tout ce dont vous avez besoin est déjà là."
  }, {
    question: 'Combien de temps avant de voir des résultats ?',
    answer: "Dès la première nuit, le calme physique s'installe en moins de 10 minutes. Vous sentirez vos muscles se relâcher et votre rythme cardiaque ralentir. Les résultats sont immédiats — c'est l'un des avantages d'agir par le corps plutôt que par la pensée."
  }];
  return <section className="w-full py-24 px-6" style={{
    background: '#0D1B2A'
  }} data-id="element-7">
      <div className="max-w-3xl mx-auto" data-id="element-8">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-9">
          <div className="amber-divider mb-8" data-id="element-10" />
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-11">
            Questions fréquentes
          </h2>

          <div className="space-y-4" data-id="element-12">
            {faqs.map((faq, index) => <FAQCard key={index} item={faq} index={index} data-id="element-13" />)}
          </div>
        </div>
      </div>
    </section>;
}